<app-debug-tool (taskID)="handleDebug($event)"></app-debug-tool>
<div class="container">
  <mat-card class="card">
    <mat-card-header>
      <mat-card-title>
        <span>{{ 'Game.Task' | translate }} {{ currentIndex + 1 }} / {{ tasks.length }}</span>
        <span>{{ 'Game.Failed' | translate }}: {{ failedCounter }}</span>
      </mat-card-title>
    </mat-card-header>
    <div class="name-wrapper">
      <div class="player">
        <h1>{{player}}</h1>
      </div>
    </div>
    <mat-card-content>
      <p [innerHTML]="text" appLinkShareHandler class="text"></p>
    </mat-card-content>
    
    <mat-card-actions>
      <app-timer *ngIf="!taskFinished" [seconds]="currentTask.time" (finished)="onFinished()" class="h-100"></app-timer>
      <div class="icon-wrapper" *ngIf="taskFinished">
        <mat-icon aria-hidden="true" class="rating-button" [class.selected]="rating === 'Like'" (click)="like()">
          thumb_up
        </mat-icon>
        <mat-icon aria-hidden="true" class="rating-button" [class.selected]="rating === 'Dislike'" (click)="dislike()">
          thumb_down
        </mat-icon>
      </div>
      <button *ngIf="taskFinished" class="next-button" mat-raised-button color="primary" (click)="next()">
        {{ (currentIndex !== (tasks.length - 1) ? 'NextTask' : 'Next') | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</div>